import axios from 'axios'

const API_PATH = 'api/v2/admins/stock_opname_entries'

const StockOpnameEntriesApiV2 = {
  get: async ({ q = '', scope = 'all', stock_opname_id = '', page = 1, per_page = 20 } = {}) => {
    const params = {
      scope: scope || 'all',
      page,
      per_page
    }

    const normalizedQuery = q.toString().trim()
    if (normalizedQuery) params.q = normalizedQuery
    if (stock_opname_id) params.stock_opname_id = stock_opname_id

    const response = axios.get(API_PATH, { params })
    return response
  },

  show: async (id) => {
    const path = `${API_PATH}/${id}`
    const response = axios.get(path)
    return response
  },

  update: async ({ id, values }) => {
    const path = `${API_PATH}/${id}`
    const payload = {
      stock_opname_entry: values
    }

    const response = axios.patch(path, payload)
    return response
  }
}

export default StockOpnameEntriesApiV2
